(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  class SortByHandler extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('.disclosure__link').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.button.innerHTML = event.target.dataset.name;
      event.target.closest('ul').querySelector('.animation-underline--active').classList.remove("animation-underline--active");
      event.target.classList.add("animation-underline--active");
      if(document.getElementById('SortBy')){
        document.getElementById('SortBy').value = event.target.dataset.value;
        document.getElementById('FacetFiltersForm').dispatchEvent(new Event('input'));
      }
      else{
        document.getElementById('SortBy-mobile').value = event.target.dataset.value;
        document.getElementById('FacetFiltersFormMobile').dispatchEvent(new Event('input'));
      }
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      var _this = this;
      setTimeout(function(){_this.hidePanel();}, 150)
    }
  }

  customElements.define('sort-by-select', SortByHandler);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      connectedCallback() {
        super.connectedCallback && super.connectedCallback();
        if (this.brancheNav) return;
        this.brancheNav = true;
        const barre = this.querySelector('[data-media-barre]');
        if (barre) barre.addEventListener('pointerup', (e) => e.stopPropagation());
        this.querySelectorAll('[data-media-prev], [data-media-next]').forEach((bouton) => {
          bouton.addEventListener('click', (e) => {
            e.stopPropagation();
            this.deplacer(bouton.hasAttribute('data-media-next') ? 1 : -1);
          });
        });

        /* Le clic sur l'image agrandit au lieu de fermer. Le fond, lui, ferme
           toujours : c'est le geste attendu d'une visionneuse. */
        const zone = this.querySelector('.product-media-modal__content');
        if (zone) {
          zone.addEventListener('pointerup', (e) => {
            /* La fenetre se ferme sur tout pointerup de souris. Trois cas
               doivent l'en empecher : le clic sur l'image, un glissement qui
               vient de se terminer, et n'importe quel clic pendant que l'image
               est agrandie. Le troisieme est indispensable : le glissement
               capture le pointeur sur la zone, donc le pointerup final ne
               porte plus sur l'image et passait au travers des deux premiers. */
            if (zone.classList.contains('est-zoome')) { e.stopPropagation(); return; }
            if (this.glissement && this.glissement.parcouru > 6) { e.stopPropagation(); return; }
            if (e.target.closest('[data-media-id]')) e.stopPropagation();
          });
          zone.addEventListener('click', (e) => {
            const media = e.target.closest('img[data-media-id]');
            if (!media) return;
            e.stopPropagation();
            /* Un glissement se termine par un clic : sans ce garde-fou, se
               deplacer dans l'image la refermerait a chaque fois. */
            if (this.glissement && this.glissement.parcouru > 6) return;
            this.basculerZoom(media, e);
          });

          zone.addEventListener('pointerdown', (e) => {
            if (!zone.classList.contains('est-zoome')) return;
            if (!e.target.closest('img[data-media-id]')) return;
            this.glissement = {
              x: e.clientX, y: e.clientY,
              gauche: zone.scrollLeft, haut: zone.scrollTop,
              parcouru: 0,
            };
            zone.classList.add('est-tire');
            if (zone.setPointerCapture) zone.setPointerCapture(e.pointerId);
          });
          zone.addEventListener('pointermove', (e) => {
            const g = this.glissement;
            if (!g) return;
            const dx = e.clientX - g.x, dy = e.clientY - g.y;
            g.parcouru = Math.max(g.parcouru, Math.abs(dx) + Math.abs(dy));
            zone.scrollLeft = g.gauche - dx;
            zone.scrollTop = g.haut - dy;
          });
          const finGlissement = () => {
            zone.classList.remove('est-tire');
            /* On garde l'objet le temps que le clic qui suit soit traite. */
            setTimeout(() => { this.glissement = null; }, 0);
          };
          zone.addEventListener('pointerup', finGlissement);
          zone.addEventListener('pointercancel', finGlissement);
          zone.addEventListener('dragstart', (e) => e.preventDefault());
        }
        this.addEventListener('keyup', (e) => {
          if (e.code === 'ArrowRight') this.deplacer(1);
          if (e.code === 'ArrowLeft') this.deplacer(-1);
        });
      }

      basculerZoom(image, evenement) {
        const zone = this.querySelector('.product-media-modal__content');
        if (zone.classList.contains('est-zoome')) {
          zone.classList.remove('est-zoome');
          image.style.width = '';
          image.style.height = '';
          image.style.maxWidth = '';
          image.style.maxHeight = '';
          image.sizes = '(min-width: 750px) calc(100vw - 22rem), 1100px';
          zone.scrollTo(0, 0);
          return;
        }
        /* Le point vise, en proportion de l'image AVANT agrandissement. */
        const cadre = image.getBoundingClientRect();
        const rx = (evenement.clientX - cadre.left) / cadre.width;
        const ry = (evenement.clientY - cadre.top) / cadre.height;

        /* Un cran d'agrandissement, pas la taille native du fichier. Laisser
           l'image reprendre ses dimensions d'origine donnait un grossissement
           de trois a quatre fois selon la photo : on perdait le produit de vue
           des le premier clic. Deux fois la taille affichee suffit a lire une
           etiquette, et reste navigable. */
        const facteur = 2;
        const largeurZoom = Math.round(cadre.width * facteur);

        zone.classList.add('est-zoome');
        image.style.maxWidth = 'none';
        image.style.maxHeight = 'none';
        image.style.width = largeurZoom + 'px';
        image.style.height = 'auto';
        /* Sans forcer `sizes`, le navigateur garde la source choisie pour
           l'affichage ajuste et l'agrandissement sort flou. On ne demande que
           ce qui est affiche, pas 4096 px. */
        image.sizes = largeurZoom + 'px';

        /* Le recentrage doit se refaire a chaque fois que la taille change :
           au changement de classe, puis a l'arrivee de la source haute
           definition. Calcule une seule fois, il tombait sur les dimensions de
           l'image ajustee, d'ou l'atterrissage en haut a gauche. */
        const recentrer = () => {
          zone.scrollLeft = rx * zone.scrollWidth - zone.clientWidth / 2;
          zone.scrollTop = ry * zone.scrollHeight - zone.clientHeight / 2;
        };
        recentrer();
        requestAnimationFrame(() => { recentrer(); requestAnimationFrame(recentrer); });
        image.addEventListener('load', recentrer, { once: true });
        if (image.decode) image.decode().then(recentrer).catch(() => {});
      }

      medias() {
        return Array.from(this.querySelectorAll('.product-media-modal__content > [data-media-id]'));
      }

      deplacer(pas) {
        const liste = this.medias();
        if (liste.length < 2) return;
        const courant = liste.findIndex((m) => m.classList.contains('active'));
        const suivant = (courant + pas + liste.length) % liste.length;
        this.montrer(liste[suivant].getAttribute('data-media-id'));
      }

      montrer(id) {
        const zone = this.querySelector('.product-media-modal__content');
        if (zone) { zone.classList.remove('est-zoome'); zone.scrollTo(0, 0); }
        this.medias().forEach((m) => m.classList.toggle('active', m.getAttribute('data-media-id') === id));
        const active = this.querySelector(`.product-media-modal__content > [data-media-id="${id}"].active`);
        if (!active) return;
        const gabarit = active.querySelector('template');
        const contenu = gabarit ? gabarit.content : null;
        if (active.nodeName === 'DEFERRED-MEDIA' && contenu && contenu.querySelector('.js-youtube')) {
          active.loadContent();
        }
      }

      showActiveMedia() {
        const liste = this.medias();
        if (!liste.length) return;
        /* L'ouvreur peut etre le bouton qui porte l'identifiant, ou un parent
           qui ne le porte pas : on cherche dans les deux, et a defaut on ouvre
           sur la premiere image plutot que sur un ecran vide. */
        let id = this.openedBy && this.openedBy.getAttribute('data-media-id');
        if (!id && this.openedBy) {
          const porteur = this.openedBy.querySelector('[data-media-id]')
            || this.openedBy.closest('[data-media-id]');
          if (porteur) id = porteur.getAttribute('data-media-id');
        }
        if (!id || !liste.some((m) => m.getAttribute('data-media-id') === id)) {
          id = liste[0].getAttribute('data-media-id');
        }
        this.montrer(id);
      }
    }

    if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  class SortByHandler extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('.disclosure__link').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.button.innerHTML = event.target.dataset.name;
      event.target.closest('ul').querySelector('.animation-underline--active').classList.remove("animation-underline--active");
      event.target.classList.add("animation-underline--active");
      document.getElementById('SortBy').value = event.target.dataset.value;
      document.getElementById('FacetFiltersForm').dispatchEvent(new Event('input'));
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      var _this = this;
      setTimeout(function(){_this.hidePanel();}, 150)
    }
  }

  customElements.define('sort-by-select', SortByHandler);

  } catch(e) { console.error(e); }
})();
})();
